import React, { useState, useRef, useEffect } from 'react'
import {
  Button,
  Form,
  Modal,
  Checkbox,
  Input,
  Space,
  TableColumnsType,
  Table,
  Dropdown,
  message,
  DatePicker,
  Select,
  Tooltip,
  Spin,
} from 'antd'
import {
  CloseIco,
  DateIco,
  ModalCloseIco,
  PensilIco,
  PlusIco,
  RefreshIco,
} from '../../../modules/CustomIcons'

import './index.scss'
import { OWNACCOUNT, Spinner } from 'constants/constants'
import SvgRectPlus from 'assets/images/icons/SvgRectPlus'
import { t } from 'i18next'
import SortableColumn from 'components/Table/ColumnSort'

import { DownOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons'
import type {
  InputRef,
  TableColumnType,
  MenuProps,
  DatePickerProps,
} from 'antd'
import type { FilterDropdownProps } from 'antd/es/table/interface'
import Highlighter from 'react-highlight-words'
import moment from 'moment'
import WarningModal from 'components/WarningModal'
import SuccessOrErrorModal from 'components/SuccessOrErrorModal'
import SearchableColumn from 'components/Table/ColumnSearch'
import DocumentsSearchableColumn from 'components/Table/DocumentsColumnSearch'
import TableComponent from 'components/Table/index'
import InputField from 'components/InputField'
import CustomTooltip from '../../components/Tooltip'
import SelectFieldDocuments from './selectDomunetsModal/index'
import FullScreenLoading from 'components/FullScreenLoading'

interface DataType {
  key: string
  docId: React.Key
  docName: string
  docNumAbsent: boolean
  docNum: string
  docDate: string
  docNote: string
  isUsed: Boolean
  docNameLabel: string
  docNameId: number
}

const DocumentsModal: React.FC<ModalProps> = ({
  children,
  onOk,
  visible,
  title,
  onCancel,
  className,
  width,
  onSuccessClose,
  height,
  okText,
  footer,
  refreshData,
  rub,
  onDisabled,
  dataModal,
  saveDocumentsModal,
}) => {
  const endOfListRef: any = useRef(null)
  const [buttonClicked, setButtonClicked] = useState(0)
  const [savedModal, setSavedModal] = useState(false)
  const [documentsData, setDocumentsData] = useState([])

  const [documentsDataoriginal, setDocumentsDataoriginal] = useState([])
  const [searchText, setSearchText] = useState('')
  const [searchedColumn, setSearchedColumn] = useState('')
  const [documentIdCount, setDocumentIdCount] = useState(11)
  const [documentsCount, setDocumentsCount] = useState(0)
  const [erroredData, setErroredData] = useState([])
  const [checkedDocuments, setCheckedDocuments] = useState([])
  const [savedDocuments, setSaveDocuments] = useState('')
  const [savedDocumentsLength, setSaveDocumentsLength] = useState([])
  const [form] = Form.useForm()
  const [filtereValues, setFilteredValues] = useState({
    docNum: '',
    docDate: '',
    docNote: '',
    docName: '',
  })

  const [saveDisable, setSaveDisabled] = useState(true)
  const searchInput = useRef<InputRef>(null)
  const [tableLoading, settableLoading] = useState(false)
  const [documentsDataoriginalSort, setdocumentsDataoriginalSort] = useState([])
 
 
  useEffect(() => {
    if (saveDisable) {
      onDisabled(saveDisable)
    }
  }, [saveDisable])

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps['confirm'],
    dataIndex: DataIndex
  ) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const handleReset = (clearFilters: () => void) => {
    clearFilters()
    setSearchText('')
  }

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={''}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Axtar
          </Button>
          {/* <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Sıfırla
                    </Button> */}
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false })
              setSearchText((selectedKeys as string[])[0])
              setSearchedColumn(dataIndex)
            }}
          >
            Filterlə
          </Button>
          {/* <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        bağla
                    </Button> */}
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value, record) => {

      return record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase())
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100)
      }
    },
    // render: (text) =>
    //     searchedColumn === dataIndex ? (
    //         <Highlighter
    //             highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
    //             searchWords={[searchText]}
    //             autoEscape
    //             textToHighlight={text ? text.toString() : ''}
    //         />
    //     ) : (
    //         text
    //     ),
  })

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    console.log('click', e)
  }
  const itemsRub = [
    {
      label: 'Договор',
      value: 'Dogov',
      code: 'ДОГОВ',
      key: 1,
    },
    {
      label: 'Инвойс',
      value: 'Inv',
      code: 'ИНВ',
      key: 2,
    },
    {
      label: 'Заказ на закупку',
      value: 'Zakaz na zakupku',
      code: 'ЗАК.НА ЗАКУПКУ',
      key: 3,
    },
    {
      label: 'Дебетовое авизо',
      value: 'Debet.avizo',
      code: 'ДЕБЕТ.АВИЗО',
      key: 4,
    },
    {
      label: 'Декларация',
      value: 'Dekl',
      code: 'ДЕКЛ',
      key: 5,
    },
    {
      label: 'Письмо',
      value: 'Pisxmo',
      code: 'ПИСЬМО',
      key: 6,
    },
    {
      label: 'Решение учредителей',
      value: 'Req.ucreditelei',
      code: 'РЕШ.УЧРЕДИТ.',
      key: 7,
    },
    {
      label: 'Решение суда',
      value: 'Req.suda',
      code: 'РЕШ.СУДА',
      key: 8,
    },
    {
      label: 'Док., подтверждающий поступл. средств',
      value: 'Dok.o postupl.sredstv',
      code: 'ДОК.О ПОСТУПЛ.СРЕДСТВ',
      key: 9,
    },
  ]
  const items = [
    {
      label: 'Contract',
      value: 'Contract',
      code: 'CNT',
      key: 1,
    },
    {
      label: 'Invoice',
      value: 'Invoice',
      code: 'INV',
      key: 2,
    },
    {
      label: 'Purchase Order',
      value: 'Purchase Order',
      code: 'PO',
      key: 3,
    },
    {
      label: 'Debit Note',
      value: 'Debit Note',
      code: 'DN',
      key: 4,
    },
    {
      label: 'GB',
      value: 'GB',
      code: 'GB',
      key: 5,
    },
    {
      label: 'Letter',
      value: 'Letter',
      code: 'LETTER',
      key: 6,
    },
    {
      label: "Shareholders' resolution",
      value: "Shareholders' resolution",
      code: 'SHAREHOLD.RESOL',
      key: 7,
    },
    {
      label: "Court's decision",
      value: "Court's decision",
      code: 'COURT.DECIS',
      key: 8,
    },
    {
      label: 'Incoming SWIFT',
      value: 'Incoming SWIFT',
      code: 'INC.SWIFT',
      key: 9,
    },
  ]

  useEffect(() => {
    
    if (visible) {
      

      let tempData = JSON.parse(JSON.stringify(dataModal))
   
      setDocumentsData(tempData)
      setDocumentsDataoriginal(tempData)
      setdocumentsDataoriginalSort(tempData)

      let usedCount = dataModal.filter((r: any) => r.isUsed)
  

      if (usedCount.length > 0) {
        setSaveDocumentsLength(usedCount)
      
        setDocumentsCount(usedCount.length)
        setErroredData([])
      } else if (usedCount.length === 0) {
  
        setDocumentsCount(0)
        setSaveDisabled(true)
        setSaveDocuments('')
        setSaveDocumentsLength([])
        setCheckedDocuments([])
        setErroredData([])
      }
    }
  }, [visible])

  const menuProps = {
    items,
    onClick: handleMenuClick,
  }
  
      
  
  
  const handleCheckIsUsed = async(record: any) => {
    await setSaveDisabled(true)
    let data = documentsData
   console.log(record)
    let dataIndex = documentsData.findIndex((c) => c.key === record.key)
    if (
      record.docName !== '' ||
      record.docDate !== '' ||
      record.docNote !== '' ||
      record.docNum !== '' || record.docNumAbsent
    ) {
      console.log(record)
      data[dataIndex].isUsed = true
    } else {
      data[dataIndex].isUsed = false
    }
    const docCount = data.filter((c) => c.isUsed).length
    let tempData = JSON.parse(JSON.stringify(data))
    setDocumentsCount(docCount)
    setDocumentsData(tempData)
    setDocumentsDataoriginal(tempData)
    setdocumentsDataoriginalSort(tempData)
  
  }

  const handleDocNameChange = async(e: any, record: any) => {
   
    await setSaveDisabled(true)
    // settableLoading(true)
    let dataIndex = documentsData.findIndex((c) => c.key === record.key)
    documentsData[dataIndex].docName = e
    if (rub) {
      documentsData[dataIndex].docNameLabel = itemsRub.find((r) => r.value === e)?.label
      documentsData[dataIndex].docNameId = itemsRub.find((r) => r.value === e)?.key
      if (e !== '') {
        documentsData[dataIndex].isUsed = true
      } else {
        
        handleCheckIsUsed(documentsData[dataIndex])
      }
    } else {
       

      documentsData[dataIndex].docNameLabel = items.find((r) => r.value === e)?.label
      documentsData[dataIndex].docNameId = items.find((r) => r.value === e)?.key
      if (e !== '') {
        documentsData[dataIndex].isUsed = true
       

      } else {
        handleCheckIsUsed(documentsData[dataIndex])
        
      }
    }

    const docCount = documentsData.filter((c) => c.isUsed).length
    let tempData = JSON.parse(JSON.stringify(documentsData))
 
    setDocumentsCount(docCount)
    setDocumentsData(tempData)
    setDocumentsDataoriginal(tempData)
    setdocumentsDataoriginalSort(tempData)
    // settableLoading(false)
  }

  const handleNumberCheck = async(e: any, record: any) => {
    let data = documentsData
    await setSaveDisabled(true)
 
    // settableLoading(true)

    let dataIndex = documentsData.findIndex((c) => c.key === record.key)
    data[dataIndex].docNumAbsent = e.target.checked
    if (e.target.checked) {     
      data[dataIndex].docNum = ''
      data[dataIndex].isUsed = true
     
    } else {
      handleCheckIsUsed(data[dataIndex])
  

    }
    const docCount = data.filter((c) => c.isUsed).length
    let tempData = JSON.parse(JSON.stringify(data))
 
    setDocumentsCount(docCount)
    
    setDocumentsDataoriginal(tempData)
    setdocumentsDataoriginalSort(tempData)
    setDocumentsData(tempData)
    // settableLoading(false)
    
  }

  const handleDocumentNumber = async(e: any, record: any) => {
    await setSaveDisabled(true)

    let data = documentsData

    let dataIndex = documentsData.findIndex((c) => c.key === record.key)
    data[dataIndex].docNum = e.target.value
  
    if (
      e.target.value !== '' &&
      e.target.value !== null &&
      e.target.value !== undefined
    ) {
      data[dataIndex].isUsed = true
    } else {
      handleCheckIsUsed(data[dataIndex])
    }
    const docCount = data.filter((c) => c.isUsed).length
  
    setDocumentsCount(docCount)
    setDocumentsDataoriginal(data)
    setdocumentsDataoriginalSort(data)
    setDocumentsData(data)
  }

  const handleDocNote = async(e: any, record: any) => {
    console.log(e.target.value)
   
    await setSaveDisabled(true)

    let data = documentsData
    
    let dataIndex = documentsData.findIndex((c) => c.key === record.key)
    data[dataIndex].docNote = e.target.value
   
    if (
      e.target.value !== '' &&
      e.target.value !== null &&
      e.target.value !== undefined
    ) {
      data[dataIndex].isUsed = true
    } else {
      handleCheckIsUsed(data[dataIndex])
    }
    const docCount = data.filter((c) => c.isUsed).length
    let tempData = JSON.parse(JSON.stringify(data))
   
    setDocumentsCount(docCount)
    setDocumentsDataoriginal(tempData)
    setdocumentsDataoriginalSort(tempData)
    setDocumentsData(tempData)
  }

  const onDateChange = async(date: any, dateString: any, record: any) => {
   await setSaveDisabled(true)
  

    let data = documentsData

    let dataIndex = documentsData.findIndex((c) => c.key === record.key)
    data[dataIndex].docDate = moment(date).format('YYYY-MM-DD')
    
    if (date !== null) {
      // settableLoading(true)
      data[dataIndex].docDate = moment(date).format('YYYY-MM-DD')
    } else {
      // settableLoading(true)
      data[dataIndex].docDate = ''
    }
    if (dateString !== '' && dateString !== null && dateString !== undefined) {
      data[dataIndex].isUsed = true
    } else {
      
      handleCheckIsUsed(data[dataIndex])
    }
    const docCount = data.filter((c) => c.isUsed).length
    let tempData = JSON.parse(JSON.stringify(data))

    setDocumentsCount(docCount)
    setDocumentsDataoriginal(tempData)
    setdocumentsDataoriginalSort(tempData)
    setDocumentsData(tempData)
    // settableLoading(false)

  }

  const disableFutureDates =(current: any) => {
    return current && current > moment().endOf('day')
  }

  const handleCheckDocuments =async () => {
    console.log(documentsData)
    let usedData = documentsData.filter((data) => data.isUsed)
    let erroredDataCount: any = []
    let checkedDocument: any = []
    usedData.map((data) => {
      console.log(data)
      if (
        data.docDate === '' ||
        data.docName === '' ||
        (!data.docNumAbsent && data.docNum === '')
      ) {
        erroredDataCount.push(data)
      } else {
        checkedDocument.push(data)
      }
    })

    if (erroredDataCount.length === 0) {
      setSaveDisabled(false)
      console.log(usedData)
    }
    if (usedData.length === 0) {
  
      setDocumentsCount(0)
    }
    setCheckedDocuments(checkedDocument)
    setErroredData(erroredDataCount)
  }

 
  const handleSaveDocuments = async() => {
 
    await setSaveDocumentsLength(checkedDocuments)
    setErroredData([])

    let temp_array_main: any = ''

    let docMap = new Map()
    const sortedItems = [...checkedDocuments].sort(
      (a, b) => a.docNameId - b.docNameId
    )
    sortedItems.forEach((row: any) => {
      let docNameDet = !rub
        ? items.find((c) => c.value === row.docName)?.code
        : itemsRub.find((c) => c.value === row.docName)?.code

   

      let docDetails = `${row?.docNum !== undefined ? row.docNum : ''} ${moment(
        row.docDate
      ).format('DD.MM.YYYY')}`

      if (docMap.has(docNameDet)) {
        let existingDetails = docMap.get(docNameDet)
        existingDetails.count += ` ${row.docId} `
        existingDetails.dates += ` ${docDetails}`
        docMap.set(docNameDet, existingDetails)
      } else {
        docMap.set(docNameDet, { count: row.docId, dates: docDetails })
      }
    })

    docMap.forEach((value, key) => {
      temp_array_main += ` ${key} ${value.dates}`
    })
    let mainDet = ''
    if (rub) {
      mainDet = temp_array_main
        .replace(/[A-Z]+/g, ' ')
        .replace(/[~!@«»№#&;$%^*\=\{\}\[\]_<>«»“”\\\|?\/]/gi, ' ')
    } else {
      mainDet = temp_array_main.replace(
        /[~!@«»№#&;$%^*\=\{\}\[\]_<>«»“”\\\|?\/]/gi,
        ' '
      )
    }
    if(documentsCount === 0 ){
      setSaveDocuments(undefined)
    }else{
      setSaveDocuments(mainDet.trim())
    }
   
    setSavedModal(true)
    saveDocumentsModal(documentsData)
  }

  const handleFilterColumn = (e: any, column: string) => {
    let newfiltereValues = { ...filtereValues }

    const value = e.target.value?.toLowerCase() || ''

    if (column in newfiltereValues) {
      newfiltereValues[column as keyof typeof newfiltereValues] = value

      ;(
        Object.keys(newfiltereValues) as (keyof typeof newfiltereValues)[]
      ).forEach((key) => {
        if (key !== column) {
          newfiltereValues[key] = ''
        }
      })

      setFilteredValues(newfiltereValues)
    }

    if (column === 'docName') {
      newfiltereValues.docName = e.target.value?.toLowerCase()
      newfiltereValues.docDate = ''
      newfiltereValues.docNum = ''
      newfiltereValues.docNote = ''
      setFilteredValues(newfiltereValues)
    }
    if (column === 'docNum') {
      newfiltereValues.docNum = e.target.value?.toLowerCase()
      newfiltereValues.docDate = ''
      newfiltereValues.docName = ''
      newfiltereValues.docNote = ''
      setFilteredValues(newfiltereValues)
    }

    if (column === 'docDate') {
      newfiltereValues.docDate = e.target.value?.toLowerCase()
      newfiltereValues.docNum = ''
      newfiltereValues.docNote = ''
      newfiltereValues.docName = ''
      setFilteredValues(newfiltereValues)
    }

    if (column === 'docNote') {
      newfiltereValues.docNote = e.target.value?.toLowerCase()
      newfiltereValues.docDate = ''
      newfiltereValues.docNum = ''
      newfiltereValues.docName = ''
      setFilteredValues(newfiltereValues)
    }

    if (documentsData && newfiltereValues) {
      const filteredData = documentsDataoriginal?.filter(
        (row: any) =>
          (newfiltereValues['docName']?.trim()
            ? row.docNameLabel
                ?.toLowerCase()
                .includes(newfiltereValues['docName'])
            : true) &&
          (newfiltereValues['docNum']?.trim()
            ? row.docNum?.toLowerCase().includes(newfiltereValues['docNum'])
            : true) &&
          (newfiltereValues['docDate']?.trim()
            ? row.docDate?.toLowerCase().includes(newfiltereValues['docDate'])
            : true) &&
          (newfiltereValues['docNote']?.trim()
            ? row.docNote?.toLowerCase().includes(newfiltereValues['docNote'])
            : true)
      )

      
      setDocumentsData(filteredData)
    }

    // setTableListForSortOriginal(old => filteredData)
    // setPagination({
    //   ...pagination,
    //   current: 1
    // })
  }

  
  const columns: TableColumnsType<DataType> = [
    {
      title: (
        <div className="foregn-table-key">
          <SortableColumn
            data={documentsData}
            setData={(e) => {
              setDocumentsData(e)
              setDocumentsDataoriginal(e)
            }}
            dataOriginal={documentsDataoriginalSort}
            type={'number'}
            parameter={'docId'}
          />
          <span>№</span>
        </div>
      ),
      dataIndex: 'docId',
      key: 'docId',
      width: '5%',
      ellipsis: false,
      // sorter: (a, b) => Number(a.docId) - Number(b.docId),
    },
    {
      title: (
        <div className="foregn-table-key">
          <SortableColumn
            data={documentsData}
            setData={(e) => {
              setDocumentsData(e)
              setDocumentsDataoriginal(e)
            }}
            dataOriginal={documentsDataoriginalSort}
            type={'string'}
            parameter={'docName'}
          />
          <Form form={form} style={{ width: '100%' }}>
            <DocumentsSearchableColumn
              large
              title={t('modal.documentname')}
              form={form}
              name={'docName'}
              filter={'searchfilter'}
              onChange={
                (event: any) => handleFilterColumn(event, 'docName')
                //     // handleFilterColumnSalary(event, 'account')
              }
              buttonClicked={buttonClicked}
              page={'salaryList'}
            />
          </Form>
        </div>
      ),
      dataIndex: 'docName',
      key: 'docName',
      
      width: '25%',
      // sorter: (a, b) => a.docName.length - b.docName.length,

      // sorter: (a, b) => a.docName.length - b.docName.length,
      // ...getColumnSearchProps('docName'),
      render(value, record, index) {
        return (
          <div className="docName">
            <Select
              className={`${
                erroredData.length > 0 && record.docName === '' && record.isUsed
                  ? 'docName-select-warning'
                  : 'docName-select'
              }`}
              bordered={false}
              value={record.docName === '' ? null : value}
              onChange={(e) => handleDocNameChange(e, record)}
              options={!rub ? items : itemsRub}
            />
            {value && (
              <Button
                ghost
                style={{ bottom: 8 }}
                className="clear-icon custom-close"
                onClick={(e) => handleDocNameChange('', record)}
                icon={<CloseIco />}
              />
            )}
          </div>
        )
      },
    },
    {
      title: (
        <div className="foregn-table-key">
          {/* <SortableColumn /> */}
          <span>{t('modal.noNumber')}</span>
        </div>
      ),
      dataIndex: 'docNumAbsent',
      key: 'docNumAbsent',
      render(checked, record, index) {
        return (
          <div style={{ display: 'flex' }}>
            <Checkbox
              onChange={async(e) => {handleNumberCheck(e, record)}}
              style={{ margin: '0 auto' }}
              checked={checked}
            />
          </div>
        )
      },
      width: '11%',
    },
    {
      title: (
        <div className="foregn-table-key">
          <SortableColumn
            data={documentsData}
            setData={(e) => {
              setDocumentsData(e)
              setDocumentsDataoriginal(e)
            }}
            dataOriginal={documentsDataoriginalSort}
            type={'string'}
            parameter={'docNum'}
          />
          <Form form={form} style={{ width: '100%' }}>
            <DocumentsSearchableColumn
              large
              title={t('modal.number')}
              form={form}
              name={'docNum'}
              filter={'searchfilter'}
              onChange={
                (event: any) => handleFilterColumn(event, 'docNum')
                //     // handleFilterColumnSalary(event, 'account')
              }
              buttonClicked={buttonClicked}
              page={'salaryList'}
            />
          </Form>
        </div>
      ),
      dataIndex: 'docNum',
      key: 'docNum',
      width: '20%',
      editable: true,
      // sorter: (a, b) => a.docName.length - b.docName.length,
      // ...getColumnSearchProps('docNum'),
      render(value, record, index) {
        if (value.length > 25) {
          return (
            <Tooltip title={value}>
              <div
                className={`docNum docNote ${
                  record.docNumAbsent ? 'docNote-input-disable' : ''
                }`}
              >
                <input
                  onChange={(e) => {
                    handleDocumentNumber(e, record)
                  }}
                  disabled={record.docNumAbsent}
                  type="text"
                  className={`${
                    erroredData.length > 0 &&
                    !record.docNumAbsent &&
                    record.docNum === '' &&
                    record.isUsed
                      ? 'docNote-input-warning'
                      : 'docNote-input'
                  } `}
                  maxLength={100}
                  name="docNote-input"
                  value={value}
                />
                {!record.docNumAbsent && (
                  <PensilIco
                    className={`${
                      erroredData.length > 0 &&
                      !record.docNumAbsent &&
                      record.docNum === '' &&
                      record.isUsed
                        ? 'docNote-input-icon-warning'
                        : ''
                    }`}
                  />
                )}
              </div>
            </Tooltip>
          )
        } else
          return (
            <div
              className={`docNum docNote ${
                record.docNumAbsent ? 'docNote-input-disable' : ''
              }`}
            >
              <input
                onChange={(e) => {
                  handleDocumentNumber(e, record)
                }}
                disabled={record.docNumAbsent}
                type="text"
                className={`${
                  erroredData.length > 0 &&
                  !record.docNumAbsent &&
                  record.docNum === '' &&
                  record.isUsed
                    ? 'docNote-input-warning'
                    : 'docNote-input'
                } `}
                maxLength={100}
                name="docNote-input"
                value={value}
              />
              {!record.docNumAbsent && (
                <PensilIco
                  className={`${
                    erroredData.length > 0 &&
                    !record.docNumAbsent &&
                    record.docNum === '' &&
                    record.isUsed
                      ? 'docNote-input-icon-warning'
                      : ''
                  }`}
                />
              )}
            </div>
          )
      },
    },
    {
      title: (
        <div className="foregn-table-key date_column date-column-documentsModal">
          <SortableColumn
            data={documentsData}
            setData={(e) => {
              setDocumentsData(e)
              setDocumentsDataoriginal(e)
            }}
            dataOriginal={documentsDataoriginalSort}
            type={'date'}
            documentsDate={true}
            parameter={'docDate'}
          />
          <Form form={form} style={{ width: '100%' }}>
            <DocumentsSearchableColumn
              large
              title={t('modal.date')}
              form={form}
              name={'docDate'}
              filter={'searchfilter'}
              onChange={(event: any) => handleFilterColumn(event, 'docDate')}
              buttonClicked={buttonClicked}
              page={'salaryList'}
            />
          </Form>
        </div>
      ),
      dataIndex: 'docDate',
      key: 'docDate',
      width: '13%',
      ellipsis: true,
      // sorter: (a, b) => new Date(a.docDate).getTime() - new Date(b.docDate).getTime(),
      // ...getColumnSearchProps('docDate'),
      render(value, record, index) {
        return (
          <div className="docDate">
            <DatePicker
              placeholder=""
              value={record.docDate === '' ? '' : moment(value)}
              onOpenChange={(open) => {
                if (open) {
                  onDateChange(null, '', record)
                }
              }}
              allowClear={false}
              disabledDate={disableFutureDates}
              format={'DD.MM.YYYY'}
              className={`${
                erroredData.length > 0 && record.docDate === '' && record.isUsed
                  ? 'docDatePicker-warning'
                  : 'docDatePicker'
              }`}
              onChange={(date, dateString) =>
                onDateChange(date, dateString, record)
              }
              bordered={false}
            />
            {value && (
              <Button
                ghost
                style={{ bottom: 4, right: 8 }}
                className="clear-icon custom-close"
                onClick={(e) => onDateChange(null, '', record)}
                icon={<CloseIco />}
              />
            )}
          </div>
        )
      },
    },
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Form form={form} style={{ width: '100%' }}>
            <DocumentsSearchableColumn
              large
              title={t('modal.note')}
              form={form}
              name={'docNote'}
              filter={'searchfilter'}
              onChange={(event: any) => handleFilterColumn(event, 'docNote')}
              buttonClicked={buttonClicked}
              page={'salaryList'}
            />
          </Form>
        </div>
      ),
      dataIndex: 'docNote',
      key: 'docNote',
      width: '30%',
      editable: true,
      // ...getColumnSearchProps('docNote'),
      render(value, record, index) {
        if (value.length > 25) {
          return (
            <Tooltip title={value}>
              <div className="docNote">
                <input
                  maxLength={150}
                  type="text"
                  className="docNote-input"
                  name="docNote-input"
                  onChange={(e) => handleDocNote(e, record)}
                  value={value}
                />
                <PensilIco />
              </div>
            </Tooltip>
          )
        }
        return (
          <div className="docNote">
            <input
              maxLength={150}
              type="text"
              className="docNote-input"
              name="docNote-input"
              onChange={(e) => handleDocNote(e, record)}
              value={value}
            />
            <PensilIco />
          </div>
        )
      },
    },
  ]

  type DataIndex = keyof DataType

  const newDefaultRow = {
    key: documentsDataoriginal.length+1,
    docId: documentsDataoriginal.length+1,
    docName: '',
    docNumAbsent: false,
    docNum: '',
    docDate: '',
    docNote: '',
    isUsed: false,
  }

  const handleInputChangeSave = (row: any) => {
    const newData = [...documentsData]
   
    const index = newData.findIndex((item) => row.key === item.key)
    const item: any = newData[index]
    let new_row_docnum: any
    let new_row_docnote: any
    if (!rub) {
      
      if (row.docNum !== ' ') {
        new_row_docnum =
          row.docNum.replaceAll(/[а-яА-ЯЁёğöəİışçĞÖƏŞÇÜü]+/g, '').toUpperCase()
            ?.length > 100
            ? row.docNum
                .replaceAll(/[а-яА-ЯЁёğöəİışçĞÖƏŞÇÜü]+/g, '')
                .toUpperCase()
                .substring(0, 100)
            : row.docNum
                .replaceAll(/[а-яА-ЯЁёğöəİışçĞÖƏŞÇÜü]+/g, '')
                .toUpperCase()
      }
      if (row.docNote !== ' ') {
        new_row_docnote =
          row.docNote
            ?.replaceAll(/[а-яА-ЯЁё]+/g, '')
            ?.replaceAll(/[~!@«»№#&;$%^*\=\{\}\[\]_<>«»“”"\\\|?\/]/gi, '')
            ?.length > 150
            ? row.docNote
                ?.replaceAll(/[а-яА-ЯЁё]+/g, '')
                ?.replaceAll(/[~!@«»№#&;$%^*\=\{\}\[\]_<>«»“”"\\\|?\/]/gi, '')
                .substring(0, 150)
            : row.docNote
                ?.replaceAll(/[а-яА-ЯЁё]+/g, '')
                ?.replaceAll(/[~!@«»№#&;$%^*\=\{\}\[\]_<>«»“”"\\\|?\/]/gi, '')
      }
      row.docNum = !row.docNumAbsent ? new_row_docnum : ''
      row.docNote = new_row_docnote
      if (row.docNum !== '' || row.docNote !== '') {
        console.log(row.docNum)
        row.isUsed = true
      }else{
        row.isUsed = false
      }
     
      newData.splice(index, 1, { ...item, ...row })
    } else {
      if (row.docNum !== ' ') {
        new_row_docnum =
          row.docNum.replaceAll(/[ğöəİışçĞÖƏŞÇÜü]+/g, '').toUpperCase()
            ?.length > 100
            ? row.docNum
                .replaceAll(/[ğöəİışçĞÖƏŞÇÜü]+/g, '')
                .toUpperCase()
                .substring(0, 100)
            : row.docNum.replaceAll(/[ğöəİışçĞÖƏŞÇÜü]+/g, '').toUpperCase()
      }
      if (row.docNote !== ' ') {
        new_row_docnote =
          row.docNote
            ?.replaceAll(/[а-яА-ЯЁё]+/g, '')
            ?.replaceAll(/[~!@«»№#&;$%^*\=\{\}\[\]_<>«»“”"\\\|?\/]/gi, '')
            ?.length > 150
            ? row.docNote
                ?.replaceAll(/[а-яА-ЯЁё]+/g, '')
                ?.replaceAll(/[~!@«»№#&;$%^*\=\{\}\[\]_<>«»“”"\\\|?\/]/gi, '')
                .substring(0, 150)
            : row.docNote
                ?.replaceAll(/[а-яА-ЯЁё]+/g, '')
                ?.replaceAll(/[~!@«»№#&;$%^*\=\{\}\[\]_<>«»“”"\\\|?\/]/gi, '')
      }
      if (row.docNum !== '' || row.docNote !== '') {
        console.log(row.docNum)
        row.isUsed = true
      }else{
        row.isUsed = false
      }
      row.docNum = !row.docNumAbsent ? new_row_docnum : ''
      row.docNote = new_row_docnote

      
      newData.splice(index, 1, { ...item, ...row })
    }

    setDocumentsDataoriginal(newData)
    setdocumentsDataoriginalSort(newData)
    setDocumentsData(newData)
  }

  const handleInputChange = (e: any, dataIndex: string) => {
    // setCopiedData(e.target.value)
  }
  const addRow2 =async() =>{
    console.log(documentIdCount)
     
    
    setDocumentIdCount(documentsDataoriginal.length+1)
  
  }
// console.log(documentIdCount)
  const addRow = async() =>{
   await addRow2()
   console.log(documentIdCount)
    setDocumentsDataoriginal([
      ...documentsDataoriginal,
      newDefaultRow,
    ])
    setdocumentsDataoriginalSort([
      ...documentsDataoriginalSort,
      newDefaultRow,
    ])
    setDocumentsData([...documentsData, newDefaultRow])
    console.log(documentsDataoriginal.length)
  
   
    // setTimeout(() => {
    //     endOfListRef.current?.scrollIntoView({ behavior: 'smooth' });
    // }, 100);
    const tableBody = document.querySelector(
      '.documentsTableWrapper'
    )
    setTimeout(() => {
      tableBody?.scrollTo({
        top: tableBody.scrollHeight,
        behavior: 'smooth',
      })
    }, 100)
  }
  return (
    <div className="notificationWarningModal">
      <Modal
        okText={okText}
        okButtonProps={{ style: { background: '#015CD1' } }}
        title={title}
        centered
        open={visible}
        onOk={onOk}
        closeIcon={<ModalCloseIco />}
        onCancel={() =>
          onCancel(
            savedDocumentsLength.length,
            savedDocuments,
            savedDocumentsLength
          )
        }
        okType="primary"
        width={width}
        className={className}
        cancelButtonProps={{ style: { display: 'none' } }}
        footer={null}
      >
        <main className="documentsModalMain">
          {
            tableLoading ? <FullScreenLoading/>:
            <TableComponent
              tableWrapperClass="documentsTableWrapper"
              tableWrapperStyle={{
                maxHeight: '60vh',
                overflowY: 'scroll',
              }}
              className="table-row-background"
              columns={columns}
              data={documentsData}
              pagination={false}
              size="small"
              handleInputChange={(e: any, dataIndex: string) =>
                handleInputChange(e, dataIndex)
              }
              handleInputChangeSave={handleInputChangeSave}
              sticky={true}
            />
          }
          <div ref={endOfListRef}></div>
        </main>
        <footer className="documentsModalFooter">
          <div className="documentsModalFooterLeft">
            <Button
              size={'large'}
              icon={<PlusIco />}
              className="addRow_btn blue-button flex align_center justify_center"
              onClick={addRow}
            >
              {t('salary.addRow')}
            </Button>
            <div className="documentsCountsContent">
              <p className="documentsCountText">{t('modal.documentsCount')}</p>
              <div className="documentsCount">
                <span className="documentsCountNumber">{documentsCount}</span>
              </div>
            </div>
            <div className="incorrectDocumentsCountsContent">
              <p className="incorrectDocumentsCountText">
                {t('modal.erroredDataLength')}
              </p>
              <div className="incorrectDocumentsCount">
                <span className="incorrectDocumentsCountNumber">
                  {erroredData?.length}
                </span>
              </div>
            </div>
          </div>
          <div className="documentsModalFooterRight">
            <Button
              size={'large'}
              htmlType="submit"
              className="blue-button  btn flex align_center justify_center"
              onClick={handleCheckDocuments}
            >
              {t('modal.check')}
            </Button>
            <Button
              size={'large'}
              htmlType="submit"
              disabled={saveDisable}
              className="blue-button  btn flex align_center justify_center"
              onClick={handleSaveDocuments}
            >
              {t('transfers.save')}
            </Button>
            <Button
              size={'large'}
              htmlType="submit"
              className="cancel_btn light-button btn flex align_center justify_center"
              onClick={() =>
               { setDocumentIdCount(documentsData.length)
                onCancel(
                  savedDocumentsLength.length,
                  savedDocuments,
                  savedDocumentsLength
                )}
              }
            >
              {t('modal.deactive')}
            </Button>
          </div>
        </footer>
      </Modal>
      {savedModal && (
        <SuccessOrErrorModal
          closeIcon={null}
          visible={savedModal}
          modalType={'success'}
          className="documentscurrency-success"
          modalTitle={' '}
          modalText={t('modal.savedData')}
          onClose={() => {
            
            setSavedModal(false)
            onSuccessClose(
              false,
              savedDocumentsLength.length,
              savedDocuments,
              savedDocumentsLength
            )
            onCancel(
              savedDocumentsLength.length,
              savedDocuments,
              savedDocumentsLength
            )
          }}
        />
      )}
       {
      tableLoading ? <FullScreenLoading /> : <></>
      }
    </div>
   
  )
}

export default DocumentsModal

// const handleFilterColumn = (e: any, column: string) => {
//     // let newfiltereValues = filtereValues

//     // if (column === 'name') {
//     //     newfiltereValues.col_2 = e.target.value?.toLowerCase()
//     //     setFilteredValues(newfiltereValues)
//     // }

//     // if (column === 'owner') {
//     //     newfiltereValues.col_3 = e.target.value?.toLowerCase()
//     //     setFilteredValues(newfiltereValues)
//     // }

//     // if (column === 'account') {
//     //     newfiltereValues.col_4 = e.target.value?.toLowerCase()
//     //     setFilteredValues(newfiltereValues)
//     // }

//     // if (column === 'amount') {
//     //     newfiltereValues.col_5 = e.target.value?.toLowerCase()
//     //     setFilteredValues(newfiltereValues)
//     // }

//     // if (column === 'description') {
//     //     newfiltereValues.col_6 = e.target.value?.toLowerCase()
//     //     setFilteredValues(newfiltereValues)
//     // }

//     // if (column === 'status') {
//     //     newfiltereValues.col_8 = e?.toLowerCase()
//     //     setFilteredValues(newfiltereValues)
//     // }

//     // if (editedTableValue && filtereValues) {
//     //     let filteredData
//     //     filteredData = editedTableValue?.filter(
//     //         (sRow) =>
//     //             sRow?.name
//     //                 .toLowerCase()
//     //                 .normalize()
//     //                 .replace(/[\u0300-\u036f]/g, '')
//     //                 .includes(filtereValues['col_2']) &&
//     //             sRow?.owner
//     //                 ?.toString()
//     //                 .toLowerCase()
//     //                 .normalize()
//     //                 .replace(/[\u0300-\u036f]/g, '')
//     //                 .includes(filtereValues['col_3']) &&
//     //             sRow?.account
//     //                 ?.toString()
//     //                 .toLowerCase()
//     //                 .normalize()
//     //                 .replace(/[\u0300-\u036f]/g, '')
//     //                 .includes(filtereValues['col_4']) &&
//     //             sRow?.amount
//     //                 ?.toString()
//     //                 .toLowerCase()
//     //                 .normalize()
//     //                 .replace(/[\u0300-\u036f]/g, '')
//     //                 .includes(filtereValues['col_5']) &&
//     //             sRow?.description
//     //                 .toLowerCase()
//     //                 .normalize()
//     //                 .replace(/[\u0300-\u036f]/g, '')
//     //                 .includes(filtereValues['col_6']) &&
//     //             sRow.status.toLowerCase().includes(filtereValues['col_8'])
//     //     )

//     //     setFilteredData(filteredData)
//     //     setFilteredDataForSort(filteredData)
//     //     setIsFiltered(true)
//     //     setCurrent(1)

//     //     if (filtereValues['col_8'] === 'all' || !e.target.value) {
//     //         form.resetFields(['status_filter'])
//     //     }
//     // }

//     // // const filteredData = editedTableValue?.filter((item: any) => {
//     // //   //@ts-ignorets-ignore
//     // //   return item[column]
//     // //     .toLowerCase()
//     // //     .includes(event.target.value.toLowerCase())
//     // // })
//     // // setFilteredData(filteredData)
//     // // setIsFiltered(true)
// }
// interface ModalProps {
//     children: React.ReactNode
//     visible: boolean
//     title: String
//     okText?: String
//     width?: number
//     height?: number
//     // setVisible: (visibility: Boolean) => void
//     onOk?: () => void
//     className?: string
//     onCancel?: () => void
//     footer?: React.ReactNode | null
// }
